import type { Blog, Page, Product, ProviderPayload } from '@/types/chat';

function mergeBySlug<T extends { slug: string }>(groups: T[][]): T[] {
  const seen = new Set<string>();
  const merged: T[] = [];

  for (const group of groups) {
    for (const item of group ?? []) {
      if (!item?.slug || seen.has(item.slug)) continue;
      seen.add(item.slug);
      merged.push(item);
    }
  }

  return merged;
}

/**
 * Merge provider payloads while preserving the first occurrence of each slug.
 * Callers pass the current/newest payload first, followed by older fallbacks.
 */
export function mergeProviderPayloads(...payloads: ProviderPayload[]): ProviderPayload {
  return {
    products: mergeBySlug<Product>(payloads.map((payload) => payload.products ?? [])),
    blogs: mergeBySlug<Blog>(payloads.map((payload) => payload.blogs ?? [])),
    pages: mergeBySlug<Page>(payloads.map((payload) => payload.pages ?? [])),
  };
}
